var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M160 0v160L46.86 273.14C75.82 302.09 115.82 320 160 320c88.37 0 160-71.63 160-160S160 0 160 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M160 0C115.82 0 75.82 17.91 46.86 46.86L160 160h160C320 71.63 248.37 0 160 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "m109.56 160-19.54-9.19 10.4-18.93-21.22 4.06-2.69-21.43-14.77 15.76-14.78-15.76-2.69 21.43-21.22-4.06 10.4 18.93L13.91 160l19.54 9.19-10.4 18.93 21.22-4.06 2.69 21.43 14.78-15.76 14.77 15.76 2.69-21.43 21.22 4.06-10.4-18.93 19.54-9.19zM42.67 62.61l6.5 9.09 10.66-3.37-6.64 8.99 6.5 9.09-10.6-3.54-6.64 9 .09-11.18-10.61-3.53 10.66-3.38.08-11.17zm0 165.53 6.5 9.09 10.66-3.38-6.64 8.99 6.5 9.09-10.6-3.53-6.64 8.99.09-11.17-10.61-3.53 10.66-3.38.08-11.17zm92.75-82.77-6.51 9.09-10.65-3.37 6.64 8.99-6.5 9.09 10.6-3.53 6.63 8.99-.08-11.18 10.6-3.53-10.65-3.37-.08-11.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.91d7d31f2f53df64eb66408a8a3f6b2e.svg";
export { ForwardRef as ReactComponent };